import React from 'react';
import { ShieldCheck } from 'lucide-react';

/* ======================================================
   DataFlow
   Sources (left) → integration & controls layer (middle) → outputs (right).
   Fixed 1640×336 canvas so it lines up inside a slide.
====================================================== */

const W = 1640;
const H = 336;
const COL = 440;
const LAYER_X = 600;
const OUT_X = W - COL;
const ROW_H = 100;
const ROW_Y = [0, 118, 236];
const MID = H / 2;

const curve = (x1, y1, x2, y2) => {
  const dx = (x2 - x1) / 2;
  return `M${x1} ${y1} C ${x1 + dx} ${y1}, ${x2 - dx} ${y2}, ${x2} ${y2}`;
};

const Node = ({ item, x, y, w = COL, h = ROW_H }) => (
  <div className={`node ${item.highlight ? 'hl' : ''}`} style={{ left: x, top: y, width: w, height: h }}>
    <b>
      {item.icon && <item.icon size={24} />}
      {item.title}
    </b>
    {item.text && <span>{item.text}</span>}
  </div>
);

const DataFlow = ({ sources, layer, outputs }) => (
  <div className="flow" aria-label="How data flows from your systems through the integration layer to finance outputs">
    <svg className="wires" width={W} height={H} viewBox={`0 0 ${W} ${H}`} aria-hidden="true">
      {ROW_Y.map((y) => (
        <path key={`in-${y}`} className="wire" d={curve(COL, y + ROW_H / 2, LAYER_X, MID)} />
      ))}
      {ROW_Y.map((y) => (
        <path key={`out-${y}`} className="wire" d={curve(LAYER_X + (OUT_X - LAYER_X - 160), MID, OUT_X, y + ROW_H / 2)} />
      ))}
    </svg>

    {sources.map((s, i) => (
      <Node key={s.title} item={s} x={0} y={ROW_Y[i]} />
    ))}

    <div className="node layer" style={{ left: LAYER_X, top: 0, width: OUT_X - LAYER_X - 160, height: H }}>
      <b>{layer.title}</b>
      <span>{layer.text}</span>
      <div className="layerChips">
        {layer.chips.map((c) => (
          <div className="layerChip" key={c}>{c}</div>
        ))}
      </div>
      <div className="layerFoot">
        <ShieldCheck size={18} /> Logged · approved · traceable to source
      </div>
    </div>

    {outputs.map((o, i) => (
      <Node key={o.title} item={o} x={OUT_X} y={ROW_Y[i]} />
    ))}
  </div>
);

export default DataFlow;
